import dependencies from './dependencies';

export default {
  dependencies,
};
